import * as React from "react";
import { connect } from "react-redux";
import uhaulStore from "../CustomRedux/UhaulStore";
import { updateCannedMessages } from "./Actions/CannedResponsesActions";
import { GetSearchTerm } from "../RefreshStats";
import { Box, Text, UnorderedList, ListItem, Anchor, Table, THead, TBody, Tr, Th, Td } from "@twilio/flex-ui/node_modules/@twilio-paste/core"

export class CMGT extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cannedMessages: [],
            attributes: null,
            newProps: { ...this.props },
            htmlString: ""
        };
    }

    state = this.getCurrentStateFromStore()

    getCurrentStateFromStore() {
        return {
            config: uhaulStore.getState().FlexReducer.config,
            cannedMessages: uhaulStore.getState().UhaulReducer.cannedMessages,
            taskContexts: uhaulStore.getState().UhaulReducer.currentTaskContext,
            customerDataList: uhaulStore.getState().UhaulReducer.customerDataList
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();

        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    componentDidMount() {
        this.unsubscribeStore = uhaulStore.subscribe(this.updateStateFromStore);
    }

    componentWillUnmount() {
        this.unsubscribeStore();
    }

    changeView = (currentElement) => {
        if (document.getElementById("divOverview")) {
            document.getElementById("divOverview").style.display = (currentElement === "Overview" ? "block" : "none");
        }
        if (document.getElementById("divAuditHistory")) {
            document.getElementById("divAuditHistory").style.display = (currentElement === "AuditHistory" ? "block" : "none");
        }
        if (document.getElementById("divBreakdown")) {
            document.getElementById("divBreakdown").style.display = (currentElement === "Breakdown" ? "block" : "none");
        }
        if (document.getElementById("divObjection")) {
            document.getElementById("divObjection").style.display = (currentElement === "Objection" ? "block" : "none");
        }
        if (document.getElementById("divCitation")) {
            document.getElementById("divCitation").style.display = (currentElement === "Citation" ? "block" : "none");
        }
        if (document.getElementById("divPayment")) {
            document.getElementById("divPayment").style.display = (currentElement === "Payment" ? "block" : "none");
        }
        if (document.getElementById("divCautionaryAlert")) {
            document.getElementById("divCautionaryAlert").style.display = (currentElement === "CautionaryAlert" ? "block" : "none");
        }
    };

    render() {
        try{
            const customerDataList = uhaulStore.getState().UhaulReducer.customerDataList;

            if(!customerDataList || customerDataList?.length <= 0){
                return <Box className="Caption"></Box>
            }
            else if (!customerDataList?.find(x => (x.SearchTerm && x.SearchTerm != "") || (x.Exception && x.Exception != ""))) {
                return <Box className="Caption"><Text>Loading Tool...</Text></Box>
            }
            else if (customerDataList && customerDataList?.length > 0) {
                var searchTerm = GetSearchTerm(this.props);
                var foundResult = customerDataList.find(x => x.SearchTerm === searchTerm);

                if (foundResult?.CustomerOrder) {

                    var result = foundResult.CustomerOrder;

                    return (
                        <Box id="divCustOverview">
                            <Box className="row">
                                <Box className="large-9 columns">
                                    <UnorderedList id="navCmgt">
                                        <ListItem><Anchor key="0" id="btnOverview" href="#Overview" data-show-div="divOverview" onClick={() => this.changeView("Overview")}>Overview</Anchor></ListItem>
                                        <ListItem><Anchor key="1" id="btnAuditHistory" href="#AuditHistory" onClick={() => this.changeView("AuditHistory")}>Audit History</Anchor></ListItem>
                                        <ListItem><Anchor key="2" id="btnBreakdown" href="#Breakdown" onClick={() => this.changeView("Breakdown")}>Breakdown</Anchor></ListItem>
                                        <ListItem><Anchor key="3" id="btnCitation" href="#Citation" onClick={() => this.changeView("Citation")}>Citation</Anchor></ListItem>
                                        <ListItem><Anchor key="4" id="btnObjection" href="#Objection" onClick={() => this.changeView("Objection")}>Objection</Anchor></ListItem>
                                        <ListItem><Anchor key="5" id="btnPayment" href="#Payment" onClick={() => this.changeView("Payment")}>Payment Methods</Anchor></ListItem>
                                        <ListItem><Anchor key="6" id="btnCautionaryAlert" href="#CautionaryAlert" onClick={() => this.changeView("CautionaryAlert")}>Cautionary Alert</Anchor></ListItem>
                                    </UnorderedList>
                                </Box>
                            </Box>
                            <Box className="row">
                                <Box className="large-12 columns">
                                    <Box className="row">
                                        <Box className="columns large-9">
                                            <Box className="row">
                                                <Box id="divOverview" className="columns large-12 divToggleHidden">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Current Orders</Text>
                                                            {this.getCurrentEquipment(result.AllContracts)}
                                                        </Box>
                                                    </Box>
                                                    <br />
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Past Orders</Text>
                                                            {this.getPastEquipment(result.AllContracts)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divAuditHistory" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Audit History</Text>
                                                            {this.getAuditHistory(foundResult.AuditHistory)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divBreakdown" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Breakdowns</Text>
                                                            {this.getBreakdowns(foundResult.BreakDownInfo)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divObjection" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Objections</Text>
                                                            {this.getObjections(foundResult.ObjectionDetails)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divCitation" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Citations</Text>
                                                            {this.getCitations(foundResult.Citations)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divPayment" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Payment Methods</Text>
                                                            {this.getPayments(foundResult.CustomerPayment)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box id="divCautionaryAlert" className="hide columns large-12">
                                                    <Box className="row">
                                                        <Box className="columns large-12">
                                                            <Text as="h2">Cautionary Alert</Text>
                                                            {this.getAlerts(foundResult.CautionaryAlert)}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>   
                    )
                }
                else {
                    return <Box />
                }
            }
        }
        catch(e){
            ExceptionLogger(window.appConfig.getLiveChatApi(), ec, "render", "Error with rendering CMGT component", null, "")         
        }

        return (<Box className="Caption">
                <Text>Unable to display customer order.</Text>
            </Box>)
    }

    getCurrentEquipment = (allContracts) => {

        if (allContracts?.Data?.length > 0 && allContracts.Data.find(x => x.Status !== "Cancelled" && x.Status !== "PastOrder")) {
            var currentUser = uhaulStore.getState().UhaulReducer.currentUser;
            var sessionGuid = (currentUser && currentUser.sessionGuid) ? currentUser.sessionGuid : "";

            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_currentEquipment" className="dataTable stripe">
                        <THead>
                            <Tr key="currentEquipment_header">
                                <Th>Contract#</Th>
                                <Th>Equipment</Th>
                                <Th>Type</Th>
                                <Th>Paid</Th>
                                <Th>Status</Th>
                                <Th>Expected <br />Pick Up</Th>
                                <Th>Expected Return</Th>
                                <Th>Links</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                allContracts.Data.map((contract, idx) => {
                                    if (contract.Status !== "Cancelled" && contract.Status !== "PastOrder" && contract.RentalType === "Equipment Rental" && contract.Status !== "Received") {
                                        return (
                                            <Tr key={idx}>
                                                <Td><Anchor href={"https://uhaul.net/equipment/contractlookup/Contract/" + contract.SystemKey} target="_blank" rel="noopener noreferrer">{contract.ExternalKey}</Anchor></Td>
                                                <Td>{contract.EquipmentList[0]}</Td>
                                                <Td>{contract.ContractType}</Td>
                                                <Td>{contract.TotalPaid}</Td>
                                                <Td>{contract.Status}</Td>
                                                <Td>{new Date(contract.PickUpExpected).toDateString()}</Td>
                                                <Td>{new Date(contract.ReturnScheduled).toDateString()}</Td>
                                                <Td><UnorderedList>
                                                    <ListItem><Anchor href={'https://poslogin.uhaul.net/secure/launchtosite/Launch.aspx?app=POS&ConsoleApp=RTA&guid=' + (sessionGuid ? sessionGuid : contract.HrTempGuid) + '&entity=' + contract.EntityNumber + '&contractId=' + contract.SystemKey + '&start=Summary&language=english'} target="_blank" rel="noopener noreferrer">POS</Anchor></ListItem>
                                                    <ListItem><Anchor href={'https://uhaul.net/equipment/contractlookup/Contract/' + contract.SystemKey} target="_blank" rel="noopener noreferrer">UHaul.net</Anchor></ListItem>
                                                </UnorderedList></Td>
                                            </Tr>
                                        )
                                    }
                                    return null;
                                }
                                )
                            }
                        </TBody>
                    </Table>
                </Box>
            )
        }
        else {
            return (<Box>There are no current orders for this customer.</Box>)
        }
    }

    getPastEquipment = (allContracts) => {
        if (allContracts?.Data?.length > 0 && allContracts.Data.find(x => x.Status !== "Reservation" && x.Status !== "Current")) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_PastRental" className="dataTable stripe">
                        <THead>
                            <Tr key="pastRental_header">
                                <Th>Date</Th>
                                <Th>Type</Th>
                                <Th>Contract/Reservation/Receipt</Th>
                                <Th>Equipment</Th>
                                <Th>Status</Th>
                                <Th>Total Paid</Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {allContracts.Data.map((contract, idx) =>  {
                                    if (contract.Status !== "Reservation" && contract.Status !== "Current" && contract.RentalType === "Equipment Rental" && contract.ContractStatus !== "Dispatched") {
                                        return (
                                            <Tr key={idx}>
                                                <Td>{new Date(contract.CreateDate).toDateString()}</Td>
                                                <Td>{contract.ContractType}</Td>
                                                <Td><Anchor href={"https://uhaul.net/equipment/contractlookup/Contract/" + contract.SystemKey} target="_blank" rel="noopener noreferrer">{contract.ExternalKey}</Anchor></Td>
                                                <Td>{contract.EquipmentList[0]}</Td>
                                                <Td>{contract.Status}</Td>
                                                <Td>{contract.TotalPaid}</Td>
                                            </Tr>
                                        )
                                    }
                                    else{
                                        return null;
                                    }
                                })
                            }
                        </TBody>
                    </Table>
                </Box>
            )
        }
        else {
            return (<Box>There are no past orders for this customer.</Box>)
        }
    }

    getAuditHistory = (auditHistory) => {
        if (auditHistory?.Data) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_AuditHistory" className="dataTable stripe">
                        <THead>
                            <Tr key="auditHistory_header">
                                <Th>Action</Th>
                                <Th>Date</Th>
                                <Th>Created By</Th>
                                <Th>System</Th>
                                <Th>Old Value</Th>
                                <Th>New Value</Th>
                                <Th>Message</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                auditHistory.Data.map((audit, idx) => (
                                    <Tr key={idx}>
                                        <Td>{audit.ChangeType}</Td>
                                        <Td>{new Date(audit.CreateDate).toDateString()}</Td>
                                        <Td>{audit.CreatedByName}</Td>
                                        <Td>{audit.SystemName}</Td>
                                        <Td>{audit.OldValue}</Td>
                                        <Td>{audit.NewValue}</Td>
                                        <Td>{audit.DisplayMessage}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>
            )
        }
        else {
            return (<Box className="Inner"></Box>);
        }
    }

    getBreakdowns = (breakDowns) => {
        if (breakDowns?.Data?.length) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_Breakdowns" className="dataTable stripe">
                        <THead>
                            <Tr key="breakdowns_header">
                                <Th>Contract #</Th>
                                <Th>Caller Name</Th>
                                <Th>Call ID</Th>
                                <Th>Date</Th>
                                <Th>Equipment</Th>
                                <Th>Call Type</Th>
                                <Th>Description</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                breakDowns.Data.map((item, idx) => (
                                    <Tr key={idx}>
                                        <Td>{item.ContractNumber}</Td>
                                        <Td>{item.Caller}</Td>
                                        <Td>{item.ID}</Td>
                                        <Td>{item.Date}</Td>
                                        <Td>{item.Equipment}</Td>
                                        <Td>{item.Type}</Td>
                                        <Td>{item.Description}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>)
        }
        else {
            return (<Box as="p">No Breakdowns found</Box>)
        }
    }

    getCitations = (citations) => {
        if (citations) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_Citations" className="dataTable stripe">
                        <THead>
                            <Tr key="citations_header">
                                <Th>Contract #</Th>
                                <Th>Violation ID</Th>
                                <Th>Amount</Th>
                                <Th>Date of Violation</Th>
                                <Th>Status</Th>
                                <Th>Contract Number</Th>
                                <Th>Violation Type</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                citations.Data.map((item, idx) => (
                                    <Tr key={idx}>
                                        <Td>{item.ContractNumber}</Td>
                                        <Td>{item.Amount}</Td>
                                        <Td>{item.DateofViolation}</Td>
                                        <Td>{item.Status}</Td>
                                        <Td>{item.ContractNumber}</Td>
                                        <Td>{item.ViolationType}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>)
        }
        else {
            return (<p>No Citations found</p>)
        }
    }

    getObjections = (objections) => {
        if (objections?.Data) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_Objections" className="dataTable stripe">
                        <THead>
                            <Tr key="objections_header">
                                <Th>Contract #</Th>
                                <Th>Caller Name</Th>
                                <Th>Call ID</Th>
                                <Th>Date</Th>
                                <Th>Equipment</Th>
                                <Th>Call Type</Th>
                                <Th>Description</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                objections.Data.map((item, idx) => (
                                    <Tr key={idx}>
                                        <Td>{item.ContractNumber}</Td>
                                        <Td>{item.Caller}</Td>
                                        <Td>{item.ID}</Td>
                                        <Td>{item.Date}</Td>
                                        <Td>{item.Equipment}</Td>
                                        <Td>{item.Type}</Td>
                                        <Td>{item.Description}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>)
        }
        else {
            return (<Box as="p">No Objections found</Box>)
        }
    }

    getPayments = (payments) => {
        if (payments?.Data) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_Payments" className="dataTable stripe">
                        <THead>
                            <Tr key="payments_header">
                                <Th>Account #</Th>
                                <Th>Name on Card</Th>
                                <Th>Exp Month and Year</Th>
                                <Th>Nick Name</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                payments.Data.map((item, idx) => (
                                    <Tr key={idx}>
                                        <Td>{item.AccountNumber}</Td>
                                        <Td>{item.CardName}</Td>
                                        <Td>{item.ExpirationMonth / item.ExpirationYear}</Td>
                                        <Td>{item.Nickname}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>
            )
        }
        else {
            return (<Box as="p">No Payment Methods found</Box>)
        }
    }

    getAlerts = (alerts) => {
        if (alerts?.Data?.Notes) {
            return (
                <Box className="content" data-section-content>
                    <Table id="dataTable_CautionaryAlert" className="stripe">
                        <THead>
                            <Tr key="cautionaryAlert_header">
                                <Th>ID</Th>
                                <Th>Create Date</Th>
                                <Th>Expiration Date</Th>
                                <Th>Customer ID</Th>
                                <Th>Note Text</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {
                                alerts.Data.Notes.map((item, idx) => (
                                    <Tr key={idx} id={item.ID}>
                                        <Td>{item.ID}</Td>
                                        <Td>{item.CreateDate}</Td>
                                        <Td>{item.ExpirationDate}</Td>
                                        <Td>{item.CustomerID}</Td>
                                        <Td>{item.NoteText}</Td>
                                    </Tr>
                                ))
                            }
                        </TBody>
                    </Table>
                </Box>
            )
        }
        else {
            return (<Box as="p">No Cautionary alerts found</Box>)
        }
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.FlexReducer.config,
        cannedMessages: store.UhaulReducer.cannedMessages,
        taskContexts: store.UhaulReducer.currentTaskContext,
        customerDataList: store.UhaulReducer.customerDataList
    };
};

export default connect(
    mapStateToProps,
    { updateCannedMessages }
)(CMGT);
